export const PersonnelPostSignUp = (model) => {
  return   $.ajax({
    url : 'Personnel/UpdatePersonnelInformation',
    data : model,

    type: 'POST'
  })


}
export const LicenceCheck = () => {

  return $.get('Personnel/IsLicenseMaxCountReached')

}

export const UpdateUserImage = (model) => {
  return   $.ajax({
    url : 'Personnel/UpdateUserImage',
    data : model,
    processData : false,
    contentType : false,
    type: 'POST'
  })


}


export const GetStates= () => {

  return $.get('Personnel/GetStates')

}


export const GetCountryTimeZone = ()=> {
  return $.get('Personnel/GetCountryTimeZone')
}



// WEBPACK FOOTER //
// ./src/components/PersonalInfo/PersonalInfo.service.js